import api from "../../../utils/api"
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getInterviewData = async(page  , limit ,  search) => {
  try {
    const res = await api.get(
      `/transactions?payment_for=MOCK INTERVIEW&sortBy=created_at&orderBy=desc&page=${page}&limit=${limit}&search=${search ? search : ""}`,
      { baseURL:  apiUrl}

    );
    return res;
  } catch (err) {
    return err;
  }
}

export const getPurchasedInterviewData = async(page  , limit ,  search) => {
  try {
    const res = await api.get(
      `/transactions/getInterviewTransactions?sortBy=created_at&orderBy=desc&page=${page}&limit=${limit}&search=${search ? search : ""}`,
      { baseURL:  apiUrl}

    );
    return res;
  } catch (err) {
    return err;
  }
}